<template>
    <div :class="{'join-us-vs':isMobile}">
        <div id="header">
            <div class="headerWrap">
            <img class="logon" src="../../../assets/img/LOGO_with_name.png" v-if="isMobile" style="width:2rem;height:2rem" @click="goHome"/>
            <img class="logo" src="../../../assets/img/LOGO_with_name.png" v-else @click="goHome">
            <div class="sign" v-if="!isMobile"><span v-for="(item,index)  in title" :key="index" :class="{'active':tabIndex==index}" @click="showIndex(index)">{{item}}</span></div>
            <div class="sign" v-else><span>{{title[tabIndex]}}</span></div>
            <button type="button" class="navbar-toggle" :class="{'active':isOpenXsMenu}" id="nav-btn"
                  @click="showDropMenuXs">
            <span class="icon-bar bar-1"></span>
            <span class="icon-bar bar-2"></span>
            <span class="icon-bar bar-3"></span>
          </button>
         </div>
       </div>
       <div id="drop-menu-xs" class="drop-menu-xs" v-if="isMobile">
          <ul class="content-xs">
              <el-menu
                :default-active="menu[tabIndex]" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#babbbd" text-color="#fff" active-text-color="#2D8FFF" style="border: 0;">
                <el-menu-item v-for="(item,index) in title" :key="index" :index="menu[index]" @click="showIndex(index)">
                  <span slot="title" >{{item}}</span>
                </el-menu-item>
              </el-menu>
          </ul>
      </div>
  </div>
</template>
<script>
 import {mapGetters} from 'vuex'
export default {
    name:"joinUsHd",
    props:['title','menu','tabindex'],
    data(){
        return{
          tabIndex:0,
          isOpenXsMenu: false,
        }
    },
    methods:{
        //点击回首页
      goHome(){
        // this.$router.push({path:'/'});
      },
      showIndex(index){
        this.$emit('changeOffers',index);
        this.tabIndex=index;
         this.isOpenXsMenu = false
           $('#drop-menu-xs').hide();
      },
      handleOpen(){

      },
      handleClose(){

      },
      showDropMenuXs() {
        if (this.isOpenXsMenu) {
           this.isOpenXsMenu = false;
           $('#drop-menu-xs').hide();
           $('body').removeClass('overflowHidden')
        } else {
          this.isOpenXsMenu = true;
           $('#drop-menu-xs').show();
           $('body').addClass('overflowHidden')
        }
      },
    },
    mounted(){
      let params = this.$route.query;
      if(params&&params.intern&&params.intern==2){ //实习招聘
          this.tabIndex=2;
      }else if(params&&params.campus&&params.campus==1){ //校招
        this.tabIndex=1;
      }
    },
    computed: {
      ...mapGetters(['isMobile', 'lang']),
      getComponentName () {
        return 'joinUsHd'
      }
    }
}
</script>
<style lang="scss" scoped>
   #header{
        position: fixed;
        width: 100%;
        top:0;
        height: 5.25rem;
        background:#babbbd;
        z-index: 10000;
        display: flex;
        justify-content: center;
        align-items: center;
        .headerWrap{
            max-width:85%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding-left: 3rem;
            .logo{
                margin-right: 6.25rem;
                height: 2.5rem;
            }
            .sign{
                // flex: 1;
                line-height: 5.25rem;
                span{
                  margin-right: 3.13rem;
                  color: #fff;
                  cursor: pointer;
                    &.active{
                    color: #2B9EFF;
                  }
                }
            }
        }
    }
.join-us-vs{
    #header{
      height:3.5rem;
      box-sizing: border-box;
      padding:0 1rem;
      .headerWrap{
        padding-left: 0;
        max-width: 100%;
        position: relative;
        // justify-content: center;
        justify-content: space-between;
        .sign{
          line-height: 3.5rem;
          text-align:center;
          color: #fff;
          font-size: 1rem;
          font-weight: 400;
          justify-content: center;
          span{
            margin-right: 0;
          }
          // position: absolute;
          // top:50%;
          // left: 50%;
          // transform: translate(-50%,-50%);
        }
          .btn-toggle {
          width: 2rem;
          height: 2rem;
        }

      .navbar-toggle {
          span {
            background: #FFFFFF;
            transition: all 0.3s;
            -webkit-transition: all 0.3s;
          }

          margin: 0;
          padding: 0;
        }

        .active {
          .bar-1 {
            transform: rotateZ(45deg) translateY(8px);
          }

          .bar-2 {
            opacity: 0;
          }

          .bar-3 {
            transform: rotateZ(-45deg) translateY(-8px);
          }
        }
      }
    }
    #drop-menu-xs{
      display: none;
      position: fixed;
      width: 100%;
      height: calc(100% - 3.5rem) !important;
      background-color: rgb(41, 48, 61);
      max-height: 100%;
      top:3.5rem;
      bottom: 0;
      z-index: 1000;
      left: 0;
      right: 0;
      ul,li{
        margin: 0;
        padding: 0;
        list-style:none;
      }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/common/newJoinUs/header.vue